export default __webpack_public_path__ + "static/media/OtherImpLinkLogo.c59b9874.svg";